<template>
  <div class="brasov">
    <h1>Kronstadt, Braşov</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/bras_1kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_1.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_2kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_2.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_3kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_3.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_4kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_4.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_5kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_5.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_6kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_6.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_7kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_7.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
      <div class="foto">
        <img src="../assets/fotos/bras_8kl.jpg" width="125" border="0" height="110" alt="Kronstadt, Braşov" 
         @click="callImageClick('Kronstadt, Braşov', 'bras_8.jpg', $event)">
        <br>Kronstadt, Braşov
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>